import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - 免费电影在线观看',
            description: '免费电影在线观看致力于为广大用户提供海量高清免费电影资源，涵盖国产、好莱坞、动漫、纪录片等全类型影片。',
            url: 'https://viewhubx.github.io/about',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '免费电影网站的资源来源是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '本站电影资源均来自互联网公开渠道，经过精心筛选和整理，确保为用户提供高质量的免费电影观看体验。',
                },
              },
              {
                '@type': 'Question',
                name: '免费电影网站是否需要下载软件？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '完全不需要！本站为纯网页版免费电影平台，无需下载任何软件或插件，打开浏览器即可在线观看。',
                },
              },
              {
                '@type': 'Question',
                name: '如何联系免费电影网站？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过邮箱 contact@freemoviehub.cn 与我们联系，我们会在24小时内回复您的咨询。',
                },
              },
            ],
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />

            <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-8">关于我们</h1>

            {/* Brand Introduction */}
            <section className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-1 h-5 rounded-full bg-accent-500" />
                <h2 className="text-lg md:text-xl font-heading text-foreground-950">品牌介绍</h2>
              </div>
              <div className="bg-background-100/50 rounded-xl border border-background-200/40 p-6 md:p-8">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  免费电影在线观看成立于2024年，是一家致力于为广大影迷提供<strong>免费高清电影资源</strong>的在线平台。我们深知观影应该是每个人都能享受的乐趣，因此始终坚持"零门槛、全免费"的核心理念，让每一位用户都能无障碍地畅享精彩电影。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  我们的资源库涵盖<strong>国产电影、好莱坞大片、日韩电影、动作片、喜剧片、科幻片、恐怖片、动漫、纪录片</strong>等全类型影片，目前已收录超过10000部高清电影资源，并且每日持续更新最新上映的影片。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  无论您是喜欢国产大片的影迷，还是热衷于好莱坞动作片的观众，亦或是钟爱动漫二次元的粉丝，在免费电影在线观看，您都能找到心仪的影片。我们相信，好的电影应该被更多人看到。
                </p>
              </div>
            </section>

            {/* Stats */}
            <section className="mb-12">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { icon: 'ri-movie-2-line', number: '10000+', label: '高清影片' },
                  { icon: 'ri-user-heart-line', number: '500万+', label: '月活跃用户' },
                  { icon: 'ri-calendar-check-line', number: '3年', label: '稳定运营' },
                  { icon: 'ri-shield-check-line', number: '100%', label: '完全免费' },
                ].map((stat, i) => (
                  <div key={i} className="bg-background-100/50 rounded-xl border border-background-200/40 p-6 text-center">
                    <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                      <i className={`${stat.icon} text-2xl text-accent-500`}></i>
                    </div>
                    <p className="font-heading text-xl md:text-2xl text-accent-500 mb-1">{stat.number}</p>
                    <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Reputation */}
            <section className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-1 h-5 rounded-full bg-accent-500" />
                <h2 className="text-lg md:text-xl font-heading text-foreground-950">用户口碑</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  {
                    name: '影迷小李',
                    text: '用了两年多了，资源更新很快，画质也很清晰。国产电影和好莱坞大片都很全，强烈推荐给喜欢看电影的朋友！',
                    rating: 5,
                  },
                  {
                    name: '电影爱好者阿强',
                    text: '分类很全，动漫和纪录片都有，全家人都能找到想看的。而且还是完全免费的，真的很良心。',
                    rating: 5,
                  },
                  {
                    name: '追剧达人小美',
                    text: '一直在用这个免费电影网站，更新速度太快了。新电影上线基本上第二天就能看到，画质也没得说。',
                    rating: 5,
                  },
                  {
                    name: '资深影迷老张',
                    text: '片子很全，很多小众电影也能找到。免费电影在线观看是我用过最好的免费电影网站，没有之一。',
                    rating: 5,
                  },
                ].map((review, i) => (
                  <div key={i} className="bg-background-100/50 rounded-xl border border-background-200/40 p-6">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, j) => (
                        <span key={j} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-accent-500 text-sm"></i>
                        </span>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">{review.text}</p>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                        <span className="text-xs font-semibold text-accent-500">{review.name[0]}</span>
                      </div>
                      <span className="text-sm font-medium text-foreground-700">{review.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* Contact Info */}
            <section className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-1 h-5 rounded-full bg-accent-500" />
                <h2 className="text-lg md:text-xl font-heading text-foreground-950">联系我们</h2>
              </div>
              <div className="bg-background-100/50 rounded-xl border border-background-200/40 p-6 md:p-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-accent-500/15 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-accent-500"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-500">contact@freemoviehub.cn</p>
                      <p className="text-xs text-foreground-400 mt-1">24小时内回复</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-accent-500/15 flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-accent-500"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-800 mb-1">服务时间</h3>
                      <p className="text-sm text-foreground-500">周一至周日</p>
                      <p className="text-xs text-foreground-400 mt-1">9:00 - 22:00</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-accent-500/15 flex items-center justify-center flex-shrink-0">
                      <i className="ri-question-answer-line text-accent-500"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-800 mb-1">常见问题</h3>
                      <p className="text-sm text-foreground-500">查看下方FAQ</p>
                      <p className="text-xs text-foreground-400 mt-1">快速解决问题</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* FAQ */}
            <section className="pb-12">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-1 h-5 rounded-full bg-accent-500" />
                <h2 className="text-lg md:text-xl font-heading text-foreground-950">常见问题</h2>
              </div>
              <div className="space-y-3">
                {[
                  { q: '免费电影网站的资源来源是什么？', a: '本站电影资源均来自互联网公开渠道，经过精心筛选和整理，确保为用户提供高质量的免费电影观看体验。' },
                  { q: '免费电影网站是否需要下载软件？', a: '完全不需要！本站为纯网页版免费电影平台，无需下载任何软件或插件，打开浏览器即可在线观看。' },
                  { q: '免费电影网站的影片画质如何？', a: '我们提供高清画质的免费电影资源，大部分影片支持720P及以上清晰度，为您带来优质的在线观看体验。' },
                  { q: '免费电影网站是否支持手机观看？', a: '是的！本站采用响应式设计，完美适配手机、平板和电脑等各类设备，让您随时随地畅享免费电影。' },
                ].map((faq, i) => (
                  <details key={i} className="group bg-background-100/50 rounded-xl border border-background-200/40 overflow-hidden">
                    <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                      <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.q}</span>
                      <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform group-open:rotate-180">
                        <i className="ri-arrow-down-s-line text-foreground-500"></i>
                      </span>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}